import {SubmissionError} from 'redux-form';
import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens

import {triggerGiftCardSubmitSuccessEvent, triggerGiftCardSubmitFailureEvent} from './edapUtils';
import transFormGiftCardFormError from './transformErrorResponse';
import logger from '../utils/clientLogger';

export const handleResponse = (response, giftCardData, shouldShowGenericError) => {
    const {submitError, errorObject: serverErrorObject} = response || {};

    const {firstName, lastName, phone, email, giftCards} = giftCardData;
    const giftCardInformation = giftCards.map(({giftCardImage, ...keepAttrs}) => keepAttrs);
    const dataToEdap = {firstName, lastName, phone, email, giftCardInformation};

    if (submitError && serverErrorObject) {
        const errorObject = transFormGiftCardFormError(serverErrorObject);
        triggerGiftCardSubmitFailureEvent(dataToEdap);
        throw new SubmissionError(errorObject);
    } else if (shouldShowGenericError) {
        logger.captureException('giftcard.submit.failure', {
            extra: `gift card data: ${dataToEdap}`
        });
        triggerGiftCardSubmitFailureEvent(dataToEdap);
        throw new SubmissionError({genericError: true});
    } else {
        triggerGiftCardSubmitSuccessEvent(dataToEdap);
    }
};

export default function formSubmit(values) {
    return request.post('/GiftCard/RedemptionRequest/api/submit')
        .send({
            name: values
        })
        .then((response) => {
            handleResponse(response.body, values, false);
        })
        .catch((err) => {
            if (!err.response) {
                throw err;
            }
            handleResponse(err.response.body, values, true);
        });
}
